import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';

const RenewalRequestList = ({
  getRequestList,
  requestList,
  requestStatus,
  updateRequestStatus,
  filters,
  getFilters,
  history
}) => {

  const headers = [
    'Site number',
    'Site Name',
    // 'Live date',
    'Expiry Date',
    'Contract Length (In months)',
    'Payment Term',
    'Contract Type',
    'Status',
    // 'Approve/Reject',
    'Contract Expiring In',
    'Request Generated At',
    'Requester Name',
    'Actions'
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [actionData, setActionData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [modificationModal, setModificationModal] = useState(false);
  const [isRejectedModal, setIsRejectedModal] = useState(false);
  const [isApprovedModal, setIsApprovedModal] = useState(false);
  const [isSomethingWentWrongModal, setIsSomethingWentWrongModal] = useState(false);
  const [payload,setPayload]=useState(null);
  
  const handleModalHide = () => setIsRejectedModal(false);
  const handleRejectModalHide = () => {
    window.location.reload();
    setIsSuccessModel(false);
  }
  
  const successIconBox = (text, func) => {
    return (
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{text}</h5>
          <Link to="#" onClick={func} className="btn btn-transparent">
            {localization.returnToApproval}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
    );
  };

  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);

  useEffect(() => {
    if (getRequestList !== null) {
      (async () => {
        setIsLoading(true);
        const page = localStorage.getItem('page');
        await getFilters();
        await getRequestList(null, page);
        setIsLoading(false);
      })();
    }
  }, [getRequestList]);

  let roleId = parseInt(localStorage.getItem('fusion-role'));
  
  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  useEffect(() => {
    const tableData = [
      "id",
      "site_no",
      "client_name",
      // "live_date",
      "expiry_date",
      "contract_length",
      "payment_term",
      "commercial_type",
      "status",
      "bucket",
      "created_at",
      "created_by_user"
    ];

    if (requestList !== null && requestList !== undefined && requestList.data) {
      const data = requestList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({[key]: element[key]})),
          // {
          //     'Approve/Reject': [element.id]
          // },
          // {
          //     Action: [
          //         {
          //             name: 'View Details', 
          //             link: `campaign-view`
          //         }
          //     ]
          // }
          (() => {
            let actionData = {};
            if (element.status == 'Pending for manager approval') {
                actionData = {
                  // 'Approve/Reject': [element.id],
                  Action: [
                            {
                                name: 'View Details and Approve',
                                // link: `request-details`
                                link: `/dashboard/contract-expiry/request-details`
                            },
                            { 
                              name: 'View Raised Requests',
                              link: `/dashboard/contract-expiry/raised-requests/${element.site_id}`
                            },
                        ]
                };
            } else {
                actionData = {
                  // 'Approve/Reject': 'No',
                  Action: [
                            {
                                name: 'View Details',
                                link: `request-details`
                            },
                            { 
                              name: 'View Raised Requests',
                              link: `/dashboard/contract-expiry/raised-requests/${element.site_id}`
                            },
                        ]
                };
            }
            return actionData;
          })()
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(requestList.total / requestList.per_page));
    }
  }, [requestList]);

  const handleApprovedModalHide = () => {
      setIsApprovedModal(false);
  };

  const handleRejectedModalHide = () => {
      setIsRejectedModal(false);
  };
  
  const handleSomethingWentWrongModalHide = () => {
    setIsSomethingWentWrongModal(false);
  };
  const updateApproval = async (data) => {
    setActionData(data);
    // setIsModal(true)
    let payload;
    if (data.action === 'accept') {
        payload = {
            request_id: data.actionObj.id,
            status: 2
        };
        setPayload(payload)
    } else {
      setIsRejectedModal(true)
        payload = {
            request_id: data.actionObj.id,
            status: 4,
            remarks:''
        };
        setPayload(payload)
    }
    setIsLoading(true);


    try {
      // Check the response from the API
      if (data.action === 'accept') {
          // Open the appropriate modal based on the action
          const response = await updateRequestStatus(payload);
          if (response) {
              setIsApprovedModal(true);
          }else {
            setIsSomethingWentWrongModal(true);
          }
        }
    } catch (error) {
        setIsSomethingWentWrongModal(true)
        console.error('API error:', error);
    } finally {
        setIsLoading(false);
    }
};
  const handleContinue = async () => {
    setIsRejectedModal(false);
    setIsLoading(true);

    // Create a new payload with updated remarks
    const updatedPayload = { ...payload, remarks: remarks.remarks };

    await updateRequestStatus(updatedPayload).then(async (response) => {
      setIsLoading(false);
      setIsSuccessModel(true);
    });
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getRequestList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getRequestList(filter, val.selected + 1);
    localStorage.setItem('page',val.selected + 1)
    setIsLoading(false);
  };

  return (
    <Layout
      title={'Renewal Requests Listing'}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
    >
      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          listFilterData={filters}
          contractRenewalFilter={true}
      />
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={requestList && requestList.data}
        pageCount={pageCount}
        srNo={requestList?.from}
        onPageChange={onPageChange}
        onChange={(data) => updateApproval(data)}
        currentPage={localStorage.getItem('page')}
      />
      <ModalPop
            title={
              actionData && actionData.action === 'reject'
                  ? localization.rejectConf
                  : localization.conf
            }
            show={isRejectedModal}
            handleModalHide={handleModalHide}
            actionData={actionData}
        >
          {actionData && actionData.action === 'reject' && (
              <Fragment>
                <div className="" >
                  <div className="">
                    <h5>{'Please add a Remarks to continue'}</h5>
                    <div className=''>
                      <TextAreaInput
                            type="text"
                            rows={3}
                            className={`inline-css scrollbar-styling`}
                            label="Add Remarks"
                            isStarRequired={true}
                            errorMsg={localization.isRequired}
                            fwidth={true}
                            style={{ width: '100% !important' }}
                            inputValue={remarks.remarks}
                            handleChange={
                              (e) => {
                                setRemarks({ ...setRemarks, remarks: e.target.value })
                              }
                            }
                            // handleChange={(val) =>{
                            //   setRemarks({ ...setRemarks, remarks: val });}
                            // }
                        />
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        className="btn btn-primary"
                        onClick={handleContinue}
                        disabled={!remarks.remarks}
                      >
                        {localization.continue}{' '}
                        <img src="../images/arrow-right.png" alt="" />
                      </Button>
                    </div>
                  </div>
                </div>
          </Fragment>
          )}
      </ModalPop>
      <ModalPop
        title={'Contract Renewal Request Rejected Successfully'}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox('Request Rejected Successfully', handleRejectModalHide)}
      </ModalPop>

      <ModalPop
                title={localization.conf}
                show={isApprovedModal}
                handleModalHide={handleApprovedModalHide}
                keyboard
                backdrop
                closeButton={false}

            >
                <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>{'Contract Renewal Request Approved Successfully'}</h5>
                <a
                    className="btn btn-primary mb-4"
                    onClick={() => window.location.reload()}
                  >
                    Back to list
                  </a>
                </div>
            </ModalPop>
    </Layout>
  );
};

export default RenewalRequestList;
